import React, { useEffect, useContext } from "react";

import AuthService from "../service/auth";
import { AccountContext } from "../provider";

export default () => {
  const [userInfo, setuserInfo] = useContext(AccountContext);

  const stateManager = ({ isLoggedIn, username, profile }) => {
    //set defaults here
    const newUser = { isLoggedIn, username: username || `unknown`, profile };
    setuserInfo(newUser);
  };

  useEffect(() => {
    AuthService.register(stateManager);
    AuthService.profile();
  }, []);

  return <></>;
};
